// extracted by mini-css-extract-plugin
module.exports = {"chartTop":"marketsChart_chartTop__3Ciyn"};